import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]兴银基金人气推荐详情页
 */
export function queryBigDataDetailUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultXyBigDataDto> {
  return resource.postNoAuth('/xyfund/queryBigDataDetail', req, config);
}

/**
 * [No Auth]兴银基金专区详情页
 */
export function queryXyFundDetailUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultXyFundInfoDto> {
  return resource.postNoAuth('/xyfund/queryXyFundDetail', req, config);
}
